<template>
  <input-base
      ref="base"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :parent-form="parentForm"
      :read-only="readOnly"
  >
    <template v-slot:editor>
      <b-input
          v-if="!fieldConfig.multiline"
          v-model="validatedField.value"
          :disabled="loading || readOnly">
      </b-input>
      <textarea
          v-else
          class="form-control"
          v-model="validatedField.value"
          rows="3"
          cols="46"
          :maxlength="5000"
          :disabled="loading || readOnly"
      ></textarea>
      <div>
        <button
            v-if="!readOnly && ! validatedField.__inTranslation"
            @click="generateInputByAi"
            class="ml-1 mr-1 btn btn-plm-action"
            :disabled="loading"
            :data-test-path="fieldConfig.fieldName"
        >
          <font-awesome-icon
              v-if="!loading"
              icon="fa-duotone fa-wand-magic-sparkles"/>
          <font-awesome-icon
              :icon="['fad', 'spinner-third']"
              v-else
              spin
              style="--fa-primary-color: #ffffff; --fa-secondary-color: #ffffff"
          />
        </button>
      </div>
    </template>
  </input-base>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput.vue";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import FormModel from "@/components/forms/FormModel";
import InputBase from "@/components/inputs/InputBase.vue";
import Rpc from "@/Rpc";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import Inspiration from "@/server/com/silkplm/model/plm/Inspiration";

export default {
  name: "FillInputsByAiRenderer",

  components: {
    InputBase,
    ReachInput
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    async generateInputByAi() {
      this.loading = true;
      let formValidatedField = this.parentForm.validatedFieldByName('productInSeasonId');
      let entityId;
      let image = [];
      if (this.mode === 'NEW' && this.parentForm.fields.image.value) {
        image.push(this.parentForm.fields.image.value);
      } else if (this.mode === 'EDIT') {
        if (formValidatedField) {
          entityId = formValidatedField.value;
          let productInSeason = new ProductInSeason();
          await productInSeason.load(entityId);
          image = productInSeason.gallery.imagesList.filter(element =>
              element.customData && element.customData?.imageTagList && element.customData?.imageTagList.some(x => x.name === "Main Picture")
          );
        }

        if (!entityId) {
          entityId = this.parentForm.validatedFieldByName('id').value;
          let inspiration = new Inspiration();
          await inspiration.load(entityId);
          image.push(inspiration.image);
        }
      } else {
        await DialogManager.info($tr('fill-inputs-renderer-upload-photo2', 'You have to upload the Photo first.'));
      }

      let promise = true;
      // let value = this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value;
      // if (value) {
      //   promise = await DialogManager.yesNo($tr('imageViewer.generateDescOverride', 'Overriding Inputs'),
      //       $tr('image-viewer-desc-override-button', 'Are you sure that you want to override inputs?'));
      // }
      if (image && image.length > 0 && promise) {
        let part = "";
        switch (this.fieldConfig.fieldName) {
          case "name":
          case "shortDescription":
            part = "title";
            break;
          case "reachDescription":
            part = "description";
            break;
          case "productAdvertise":
            part = "content";
            break;
          case "useRecommendation":
            part = "usage";
            break;
          default:
            return
        }

        let task = await Rpc.ai.GenerateDescriptionByAI.getImageDescriptionByAiSinglePart(SessionManager.defaultCustomerLanguageCode, "", image[0], part);
        this.descriptionAI = await task.finish();
        this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = this.descriptionAI[part];
      } else {
        this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = $tr('fill-inputs-no-picture', 'No Main Picture Found');
      }
      this.loading = false;
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: false},
    fieldConfig: {type: TextFormFieldConfig, required: false},
    mode: {default: null},
    parentForm: {type: FormModel}
  },

  watch: {
    validatedField: function (val) {
      // console.log('yy');
      //this.onChangeColor();
    },
    "validatedField.value": function (val) {
      // console.log('xx');
    }
  },

  data: () => ({
    descriptionAI: '',
    loading: false,
    readOnly: true
  })
}
</script>

<style scoped>

</style>
